var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7865 2L15.4532 12.6667",
    stroke: "#B8BEC7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2909 3.16639C10.426 2.77481 10.8529 2.56685 11.2445 2.70189C13.3484 3.42744 15.1199 5.04653 16.3334 7.16012C16.6613 7.73125 16.7394 8.40203 16.568 9.02053C16.4573 9.41969 16.044 9.65356 15.6449 9.5429C15.2457 9.43224 15.0118 9.01895 15.1225 8.61979C15.1882 8.38268 15.1582 8.12574 15.0326 7.90699C13.9619 6.04215 12.451 4.70467 10.7554 4.11993C10.3639 3.98489 10.1559 3.55798 10.2909 3.16639ZM6.9107 3.26272C7.06658 3.64649 6.88185 4.08395 6.49808 4.23984C4.93274 4.87566 3.54301 6.16068 2.54036 7.90705C2.37538 8.1944 2.37538 8.54749 2.54036 8.83484C4.01138 11.3969 6.29969 12.9543 8.78646 12.9543C10.552 12.9543 12.2069 12.1743 13.5503 10.8076C13.8406 10.5122 14.3155 10.5081 14.6109 10.7984C14.9063 11.0888 14.9104 11.5636 14.62 11.859C13.0435 13.463 11.0191 14.4543 8.78646 14.4543C5.62526 14.4543 2.90183 12.477 1.23952 9.58171C0.808997 8.83185 0.808994 7.91004 1.23951 7.16019C2.37663 5.1796 4.0027 3.63442 5.93359 2.85011C6.31735 2.69423 6.75482 2.87896 6.9107 3.26272Z",
    fill: "#B8BEC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7262 7.8834C10.832 8.30462 10.7979 8.74885 10.629 9.14896C10.46 9.54906 10.1654 9.88329 9.78965 10.1011C9.41391 10.319 8.97748 10.4086 8.5463 10.3564C8.11513 10.3043 7.71265 10.1132 7.3997 9.81202C7.08675 9.51086 6.88034 9.11602 6.81166 8.68717C6.74298 8.25831 6.81577 7.81876 7.01903 7.43494C7.22228 7.05111 7.54496 6.74389 7.93828 6.55969C8.3316 6.37549 8.7742 6.32433 9.19917 6.41395",
    stroke: "#B8BEC7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.3a4feca8077f12c9553bda3139db1904.svg";
export { ForwardRef as ReactComponent };